import { combineReducers } from 'redux';
import { reducer as breakpointsReducer } from './redux-slice';
export var uiReducer = combineReducers({
    breakpoints: breakpointsReducer,
});
